export const Config = {
    shazamKey: process.env.REACT_APP_SHAZAM_API_KEY,
}